(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
class MainBlog extends HTMLElement {
  constructor() {
    super();
    this.ajaxPaginationBlog();

  }


  ajaxPaginationBlog() {
    if(document.querySelectorAll('#moreload_posts').length > 0){
      let counter = 2;
      let pages = document.querySelector('#moreload_posts').dataset.pagemax;
      let maxCount = Number(pages)+1;


      //infinixscroll posts
      if (document.querySelectorAll(".infinixscroll").length > 0) {

        let scrollEventCatcher = new IntersectionObserver(function (getProduct) {

          getProduct.forEach(function (event) {

            if (event.isIntersecting == true) {

              //check url filter
              let getUrl
              if (!location.search) {
                getUrl = location.href + "?page=" + counter
              } else {
                getUrl = location.href + "&page=" + counter
              }

              //Add disabled button
              document.querySelector('#moreload_posts').disabled = true;
              //Remove class new load post card
              document.querySelectorAll('.article-column').forEach((item)=>{
                item.classList.remove('loaded-post')
              })


              setTimeout(function () {
                $.ajax({
                  url: getUrl,
                  type: "GET",
                  beforeSend: function () {
                    //add disable button
                  },
                  complete: function () {
                    //Preview product card slider -- global js
                    previewCardSlider()
                    // chnage image card when click color swatcher -- global.js
                    chnageImageCardProdactPreview()
                    //preview product
                    clickPreviewProductPopup()
                  },
                  success: function (data) {
                    counter++;

                    let html_div = document.createElement('div');
                    html_div.innerHTML = data;

                    //add class new load post card
                    html_div.querySelectorAll('.article-column').forEach((item)=>{
                      item.classList.add('loaded-post')
                    })

                    let loadedData = html_div.querySelector('#blog-articles-grid').innerHTML;
                    // add new post
                    document.querySelector("#blog-articles-grid").innerHTML += loadedData;

                    //remove disable button
                    document.querySelector('#moreload_posts').disabled = false;
                    // remove button
                    if(counter == maxCount ) {
                      document.querySelector('#moreload_posts').parentNode.remove();
                    }
                  },
                }) //end ajax request
              }, 1000)
            }
          })
        })
        //infinix button catcher
        scrollEventCatcher.observe(document.querySelector('.infinixscroll'))
      }


      document.querySelector('#moreload_posts').addEventListener('click', function(e) {
        e.preventDefault();
        //check url filter
        let getUrl;
        if(!location.search){
          getUrl = location.href+'?page='+counter;
        }else{
          getUrl = location.href+'&page='+counter;
        }

        //Add disabled button
        document.querySelector('#moreload_posts').disabled = true;
        //Remove class new load post card
        document.querySelectorAll('.article-column').forEach((item)=>{
          item.classList.remove('loaded-post')
        })

        setTimeout(function(){

          $.ajax({
            url: getUrl,
            type:'GET',
            beforeSend: function(){
              //add disable button

            },
            complete: function(){

            },
            success: function(data){

              counter++;

              let html_div = document.createElement('div');
              html_div.innerHTML = data;

              //add class new load post card
              html_div.querySelectorAll('.article-column').forEach((item)=>{
                item.classList.add('loaded-post')
              })

              let loadedData = html_div.querySelector('#blog-articles-grid').innerHTML;
              // add new post
              document.querySelector("#blog-articles-grid").innerHTML += loadedData;

              //remove disable button
              document.querySelector('#moreload_posts').disabled = false;
              // remove button
              if(counter == maxCount ) {
                document.querySelector('#moreload_posts').parentNode.remove();
              }

            }
          });//end ajax request

        },1000)//end setTimeout

      });//end click
    }
  }
}

customElements.define('main-blog-button', MainBlog);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !window.DesignMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }

            //Preview product card slider -- global js
            previewCardSlider()
            // chnage image card when hover color swatcher -- global.js
            chnageImageCardProdactPreview()

          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
